import { getDynamicDateVariablesByCategory } from "@/lib/dateUtils"

/**
 * Build variable picker entries for workflow email message editors.
 */
export function buildWorkflowInsertVariables(
  upstreamVariables = [],
  systemVariables = [],
  { includeDates = true, includeFormFields = true } = {},
) {
  const variables = []
  const seen = new Set()

  const add = (entry) => {
    const token = entry.insertToken || `{{ ${entry.key} }}`
    if (!entry.key || seen.has(token)) {
      return
    }
    seen.add(token)
    variables.push(entry)
  }

  upstreamVariables.forEach((variable) => {
    if (variable.type === "form_field") {
      if (!includeFormFields) {
        return
      }
      add({
        key: variable.name,
        label: variable.label || variable.name,
        group: variable.source || "form",
        insertToken: `{{${variable.name}}}`,
      })
      return
    }

    add({
      key: variable.name,
      label: variable.label || variable.name,
      group: "workflow",
      insertToken: `{{${variable.name}}}`,
    })
  })

  systemVariables.forEach((variable) => {
    add({
      key: variable.name,
      label: variable.description || variable.name,
      group: variable.group || "system",
      insertToken: `{{${variable.name}}}`,
    })
  })

  if (includeDates) {
    const categories = getDynamicDateVariablesByCategory()
    Object.values(categories).forEach((category) => {
      category.variables.forEach((variable) => {
        add({
          key: variable.key,
          label: variable.label,
          group: "dates",
          insertToken: `~${variable.key}~`,
        })
      })
    })
  }

  return variables
}
